export default __webpack_public_path__ + "e039d674bb54589ad51c20573b989f05.png";